import "reflect-metadata";

import "assets/css/reset.css";
import "assets/css/fonts.css";
import "assets/css/core.css";

import React from "react";
import reportWebVitals from "./reportWebVitals";
import {
	breadcrumbsIntegration,
	browserTracingIntegration,
	init,
	replayIntegration,
} from "@sentry/react";
import {createRoot} from "react-dom/client";
import {
	DIContainer,
	services,
	providers,
	stores,
	controllers,
} from "data/services/locator/locator_container.service";
import {InjectionProvider} from "data/services/locator/locator_provider.service";
import {SENTRY_DSN_URL} from "data/constants";
import {WidgetLoaderComponent} from "views/components/widget_loader/widget_loader.component";
import Widget from "views/pages/widget/widget.page";

if (SENTRY_DSN_URL) {
	init({
		dsn: SENTRY_DSN_URL,
		integrations: [
			browserTracingIntegration(),
			replayIntegration(),
			breadcrumbsIntegration({
				console: false,
			}),
		],
		environment: process.env.REACT_APP_SENTRY_ENV || "development",
		allowUrls: ["*.geniussports.com", "cflscoreboard.cfl.ca"],
		denyUrls: [
			"quantcast",
			"xsca",
			// browser's extensions
			/extensions\//i,
			/^chrome:\/\//i,
			/^moz-extension:\/\//i,
		],
		sampleRate: 0.1,
		ignoreErrors: [
			"Request aborted",
			"timeout exceeded",
			"Non-Error promise rejection captured",
			"Access is denied for this document",
		],
	});
}

const root = document.getElementById("root");

if (!root) {
	throw Error("Root element was not found");
}

DIContainer.load(services, providers, stores, controllers);

createRoot(root).render(
	<React.StrictMode>
		<InjectionProvider container={DIContainer}>
			<WidgetLoaderComponent>
				<Widget />
			</WidgetLoaderComponent>
		</InjectionProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
